import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { Link as RouterLink } from 'react-router-dom';
import { arrayOf, bool, shape, string } from 'prop-types';

const FooterMenu = ({ menuItems }) => (
	<Stack
		direction='row'
		justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
		rowGap={3}
		columnGap={3}
		flexWrap='wrap'
	>
		{menuItems &&
			menuItems.map(menuItem =>
				!menuItem.external ? (
					<Link
						key={menuItem.key}
						component={RouterLink}
						color='secondary'
						variant='body2'
						to={menuItem.path}
						target={menuItem.newTab ? '_blank' : '_self'}
						rel={menuItem.newTab ? 'noopener' : ''}
						underline='hover'
						sx={{
							flexShrink: 0,
						}}
					>
						{menuItem.label}
					</Link>
				) : (
					<Link
						key={menuItem.key}
						color='secondary'
						variant='body2'
						href={menuItem.path}
						target={menuItem.newTab ? '_blank' : '_self'}
						rel={menuItem.newTab ? 'noopener' : ''}
						underline='hover'
						sx={{
							flexShrink: 0,
						}}
					>
						{menuItem.label}
					</Link>
				)
			)}
	</Stack>
);

FooterMenu.propTypes = {
	menuItems: arrayOf(
		shape({
			key: string.isRequired,
			label: string.isRequired,
			path: string.isRequired,
			newTab: bool,
			external: bool,
		})
	).isRequired,
};

export default FooterMenu;
